import {
    AppIntegrationsRepository,
    TransactionsRepository,
    LicensesRepository,
    GdprActionsRepository,
    ActivationCodesRepository,
    UsersRepository,
    PaymentTypesRepository,
    AppInstancesRepository,
    DevicesRepository,
    AppPricesRepository,
    FlexiblePromotionsRepository,
    ExpiredLicensesRepository,
    RecommendationsRepository,
    dwmRepository,
    // MeRepository,
} from 'common/repositories/index';


const _serviceDependencies = ['$rootScope', '$q', 'DeviceRestService',
    'UserRestService',
    'LicenseRestService', 'AppInstanceRestService',
    'AppIntegrationRestService',
    'ErrorHandler', 'Util', 'Auth', 'PaymentTypesRestService', 'ActivationCodeRestService',
    'GdprActionsRestService', 'TransactionRestService', 'AppPricesRestService',
    'FlexiblePromotionsRestService', 'RecommendationsRestService', '$http'];

/**
 * @ngdoc service
 * @name services.DashboardResolver
 *
 * @description
 * This class is the Dashboard Resolver.
 * Here we get all the dashboard resources needed for setup.
 */
class DashboardResolver {

    /**
     * @param  {any} $rootScope
     * @param  {any} $q
     * @param  {any} DeviceRestService
     * @param  {any} UserRestService
     * @param  {any} LicenseRestService
     * @param  {any} AppInstanceRestService
     * @param  {any} AppIntegrationRestService
     * @param  {any} ErrorHandler
     * @param  {any} Util
     * @param  {any} Auth
     * @param  {any} PaymentTypesRestService
     * @param  {any} ActivationCodeRestService
     * @param  {any} GdprActionsRestService
     * @param  {any} TransactionRestService
     * @param  {any} AppPricesRestService
     * @param  {any} FlexiblePromotionsRestService
     * @param  {any} RecommendationsRestService
     */


    constructor(
        $rootScope, $q, DeviceRestService, UserRestService,
        LicenseRestService,
        AppInstanceRestService, AppIntegrationRestService,
        ErrorHandler, Util, Auth,
        PaymentTypesRestService, ActivationCodeRestService,
        GdprActionsRestService, TransactionRestService,
        AppPricesRestService, FlexiblePromotionsRestService,
        RecommendationsRestService, $http,
    ) {


        this.$q = $q;
        this.$rootScope = $rootScope;
        this.ErrorHandler = ErrorHandler;
        this.Util = Util;
        this.Auth = Auth;
        this.$http = $http;

        // resoruces promises
        this.DeviceRestService = DeviceRestService;
        this.AppIntegrationRestService = AppIntegrationRestService;
        this.AppInstanceRestService = AppInstanceRestService;
        this.LicenseRestService = LicenseRestService;
        this.UserRestService = UserRestService;
        this.PaymentTypesRestService = PaymentTypesRestService;
        this.ActivationCodeRestService = ActivationCodeRestService;
        this.GdprActionsRestService = GdprActionsRestService;
        this.TransactionRestService = TransactionRestService;
        this.AppPricesRestService = AppPricesRestService;
        this.FlexiblePromotionsRestService = FlexiblePromotionsRestService;
        this.RecommendationsRestService = RecommendationsRestService;

        // repositories
        this.DevicesRepository = DevicesRepository;
        this.AppInstancesRepository = AppInstancesRepository;
        this.LicensesRepository = LicensesRepository;
        this.UsersRepository = UsersRepository;
        this.ActivationCodesRepository = ActivationCodesRepository;
        this.GdprActionsRepository = GdprActionsRepository;
        this.TransactionsRepository = TransactionsRepository;
        this.AppPricesRepository = AppPricesRepository;
        this.FlexiblePromotionsRepository = FlexiblePromotionsRepository;
        this.ExpiredLicensesRepository = ExpiredLicensesRepository;
        this.RecommendationsRepository = RecommendationsRepository;
        this.dwmRepository = dwmRepository;

    }


    getDashboardResourcesPromise() {

        const dashboardPromise = this.$q.defer();

        // if the user doesn't have token, go to login
        if (!this.Util.getToken()) {

            dashboardPromise.reject();
            this.Auth.gotoLogin();

        } else if (this.Util.isAnonymous()) {

            dashboardPromise.reject();
            this.Auth.gotoRegister();

        } else {

            const appIntegrationsPromise = this.AppIntegrationRestService.getAllAsync();
            const usersPromise = this.UserRestService.getAllAsync();
            const paymentTypesPromise = this.PaymentTypesRestService.getAllAsync();
            const activationCodesPromise = this.ActivationCodeRestService.getAllAsync();
            const GdprActionsPromise = this.GdprActionsRestService.getAllAsync();
            const transactionsPromise = this.TransactionRestService.getAllAsync();
            const appPricesPromise = this.AppPricesRestService.getAllAsync();

            const aviraToken = this.Util.getToken();

            const aiaStatusApiPromise = this.$http({
                method: 'POST',
                url: CWCONFIG.dwm.statusURL,
                headers: {
                    Authorization: `Bearer ${aviraToken}`,
                },
                data: {
                    clientApplication: {
                        clientId: 'myavira',
                    },
                },

            });

            const getAiaMonitorData = () => {

                this.$http({
                    method: 'POST',
                    url: `${CWCONFIG.dwm.restApi}/v1/auth/tokensByPartnerToken`,
                    headers: {
                        client_id: 'avira',
                        origin: 'https://avira.com',
                        'Content-Type': 'application/json',
                    },
                    data: {
                        partner_token: aviraToken,
                    },

                }).then((response) => {

                    this.$http({
                        method: 'GET',
                        url: `${CWCONFIG.dwm.restApi}/v1/partner/members`,
                        headers: {
                            client_id: 'avira',
                            origin: 'https://avira.com',
                            access_token: response.data.access_token,
                            'Content-Type': 'application/json',
                        },

                    }).then((membersResponse) => {

                        if (this.aiaSubscriptionActive) {

                            this.dwmRepository.replace('assets', membersResponse.data);

                            const { dwmCardStatus } = membersResponse.data.primaryMember;

                            if (dwmCardStatus === 'add-more-data') {

                                this.$rootScope.showDwmAddMoreDataCard = true;

                                if (this.$rootScope.noUnreadAlerts) {

                                    this.$rootScope.showDwmCardHomepage = true;

                                }

                            }

                        }

                    }).catch(() => {});

                    this.$http({
                        method: 'GET',
                        url: `${CWCONFIG.dwm.restApi}/v1/partner/alerts`,
                        headers: {
                            client_id: 'avira',
                            origin: 'https://avira.com',
                            access_token: response.data.access_token,
                            'Content-Type': 'application/json',
                            lang_code: CWCONFIG.language === 'de' ? 'de-DE' : 'en-US',
                        },

                    }).then((alertsResponse) => {

                        this.dwmRepository.replace('alerts', alertsResponse.data);

                        let aiaUnreadAlerts = 0;

                        if (alertsResponse.data.alertList.length > 0) {

                            alertsResponse.data.alertList.forEach((alert) => {

                                if (alert.isRead === false && alert.bucket === 'inbox') {

                                    aiaUnreadAlerts += 1;

                                }

                            });

                        }

                        if (aiaUnreadAlerts > 0) {

                            this.$rootScope.showDwmCardHomepage = true;
                            this.$rootScope.showDwmUnreadNotificationsCard = true;
                            this.$rootScope.dwmCardUnreadNotifications = aiaUnreadAlerts;

                        } else if ((aiaUnreadAlerts === 0 && this.dwmLiteSubscriptionUpsell) ||
                            this.$rootScope.showDwmAddMoreDataCard) {

                            this.$rootScope.showDwmCardHomepage = true;

                        } else {

                            this.$rootScope.noUnreadAlerts = true;

                        }

                    }).catch(() => {});

                }).catch(() => {});

            };

            // below repos depend on appIntegrations to load first
            const devicesPromise = this.$q.defer();
            const appInstancesPromise = this.$q.defer();
            const licensesPromise = this.$q.defer();

            const usersPromiseQ = this.$q.defer();
            const paymentTypesPromiseQ = this.$q.defer();
            const activationCodesPromiseQ = this.$q.defer();
            const GdprActionsPromiseQ = this.$q.defer();
            const appPricesPromiseQ = this.$q.defer();
            const aiaStatusApiPromiseQ = this.$q.defer();

            // get aia status
            aiaStatusApiPromise.then((response) => {

                const dwmStatus = response.data || {};
                this.$rootScope.dwmStatus = dwmStatus;

                // root.hideAIACardInFreeStore
                const aiaTileAction = this.Util.deepFind(dwmStatus, 'products.identityAssist.tileAction');
                const dwmLiteTileAction = this.Util.deepFind(this.$rootScope.dwmStatus, 'products.dwmLite.tileAction');

                if (aiaTileAction === 'openUpsell') {

                    this.$rootScope.showAIACardInFreeStore = true;

                }

                if (aiaTileAction === 'openUpsell' || dwmLiteTileAction === 'openUpsell') {

                    this.$rootScope.showAIAWelcomeOfferBanner = true;

                } else {

                    this.$rootScope.showAIAWelcomeOfferBanner = false;

                }

                const aiaStatus = this.Util.deepFind(dwmStatus, 'products.identityAssist');
                const dwmLiteStatus = this.Util.deepFind(dwmStatus, 'products.dwmLite');

                const aiaSubscriptionStatus = this.Util.deepFind(dwmStatus, 'products.identityAssist.subscriptionStatus');
                const dwmLiteSubscriptionStatus = this.Util.deepFind(dwmStatus, 'products.dwmLite.subscriptionStatus');

                const aiaSubscriptionCancelled = aiaSubscriptionStatus === 'cancelled' || aiaSubscriptionStatus === 'none';
                this.aiaSubscriptionActive = aiaSubscriptionStatus === 'active';
                const dwmLiteSubscriptionCancelled = dwmLiteSubscriptionStatus === 'cancelled' || dwmLiteSubscriptionStatus === 'none';
                this.dwmLiteSubscriptionUpsell = dwmLiteSubscriptionStatus === 'active' && aiaTileAction === 'openUpsell';
                this.dwmLiteSubscriptionActive = dwmLiteSubscriptionStatus === 'active';

                if ((aiaStatus || dwmLiteStatus)
                    && (aiaSubscriptionCancelled ||
                        dwmLiteSubscriptionCancelled)) {

                    this.$rootScope.showDwmCardHomepage = true;

                } else {

                    this.$rootScope.showDwmCardHomepage = false;

                }

                this.dwmRepository.replace('statusApi', dwmStatus);

                if (aiaStatus || dwmLiteStatus) {

                    this.$rootScope.showDwmLeftNavigation = true;

                }

                if (this.aiaSubscriptionActive || this.dwmLiteSubscriptionActive) {

                    getAiaMonitorData();

                }

                this.$rootScope.dwmStatusLoaded = true;

                aiaStatusApiPromiseQ.resolve();

            }).catch(() => {

                this.$rootScope.showDwmLeftNavigation = false;
                this.$rootScope.dwmStatusLoaded = true;
                aiaStatusApiPromiseQ.resolve();

            });

            // get app integrations
            appIntegrationsPromise.then((response) => {

                AppIntegrationsRepository.replace(response.data.data, response.data.included);

                // get app instances
                this.AppInstanceRestService.getAllAsync().then((responseValue) => {

                    this.AppInstancesRepository.replace(responseValue.data.data);
                    appInstancesPromise.resolve();

                });

                // get licenses
                this.LicenseRestService.getAllAsync().then((responseValue) => {

                    this.LicensesRepository.replace(responseValue.data.data);
                    // save also all the expired licenses
                    this.ExpiredLicensesRepository.replace(responseValue.data.data);
                    licensesPromise.resolve();

                });

                // get devices
                this.DeviceRestService.getAllAsync().then((responseValue) => {

                    this.DevicesRepository.replace(responseValue.data.data);
                    devicesPromise.resolve();

                });

            });

            usersPromise.then((response) => {

                this.UsersRepository.replace(response.data.data);
                usersPromiseQ.resolve();

            });

            paymentTypesPromise.then((response) => {

                PaymentTypesRepository.replace(response.data.data);
                paymentTypesPromiseQ.resolve();

            });

            activationCodesPromise.then((response) => {

                this.ActivationCodesRepository.replace(response.data.data);

                const activationCodes = this.ActivationCodesRepository.getAll() || [];
                activationCodes.forEach((activationCode) => {

                    if (activationCode.attributes.promotion_id) {

                        this.FlexiblePromotionsRestService
                            .getPromotionById(activationCode.attributes.promotion_id)
                            .then((promotionResponse) => {

                                const promotionResponseArray = [];

                                promotionResponseArray.push(promotionResponse.data.data);

                                this.FlexiblePromotionsRepository.add(promotionResponseArray);

                            });

                    }

                });

                if (activationCodes.length > 0) {

                    this.RecommendationsRestService
                        .getAllAsync()
                        .then((responseValue) => {

                            this.RecommendationsRepository
                                .replace(responseValue.data.data);

                        });

                }

                activationCodesPromiseQ.resolve();

            });

            GdprActionsPromise.then((response) => {

                this.GdprActionsRepository.replace(response.data.data);
                GdprActionsPromiseQ.resolve();

            });

            transactionsPromise.then((response) => {

                this.TransactionsRepository.replace(response.data.data);

            });

            // 97% off av campaign
            // const user = MeRepository.getMyUser();
            // const userRegistrationDate = this.Util.deepFind(user, 'attributes.date_registered');
            // const campaignBreakpoint = this.Util.deepFind(CWCONFIG,
            // 'features.offerBanner.campaignBannerDaysBreakpoint') || 120;
            // const today = moment();
            // const registrtionDate = moment(userRegistrationDate);
            // const accountDays =
            //     parseInt(moment.duration(today.diff(registrtionDate)).asDays(), 10) + 1;
            // end 97% off av campaign

            // App prices and promotions get
            appPricesPromise.then((prices) => {

                const promotionsPromises = [];
                let promotionsResponses = [];

                this.AppPricesRepository.replace(prices.data.data);

                const promotions = CWCONFIG.flexiblePromotions;

                promotions.forEach((promotion) => {

                    // this.$rootScope.showFreeStorePromotionDisclaimer = true;

                    // 97% off av campaign
                    // if (accountDays <= campaignBreakpoint) {

                    //     if (promotion.product !== 'aapd5') {

                    //         promotionsPromises
                    //             .push(this.FlexiblePromotionsRestService.
                    // getPromotion(promotion));

                    //     }

                    // } else {

                    //     this.$rootScope.showFreeStorePromotionDisclaimer = true;
                    //     promotionsPromises
                    //         .push(this.FlexiblePromotionsRestService.getPromotion(promotion));

                    // }
                    // end 97% off av campaign

                    promotionsPromises
                        .push(this.FlexiblePromotionsRestService.getPromotion(promotion));

                });

                //* Promotional Campaign : get first year prices CMA disclaimer
                //* To be commented when the campaign is over
                // this.$rootScope.firstYearPrices = {};
                // const firstYearPricePromotionAntivirus = {
                //     type: 'public',
                //     source: 'cd',
                //     purchaseType: 'new',
                //     country: 'All',
                //     product: 'aapd5',
                //     runtime: 12,
                //     devices: 1,
                // };

                // const firstYearPricePromotionAIA = {
                //     type: 'public',
                //     source: 'cd',
                //     purchaseType: 'new',
                //     country: 'All',
                //     product: 'adwp1',
                //     runtime: 12,
                //     devices: 1,
                // };

                // const firstYearPricePromotionPrime5 = {
                //     type: 'public',
                //     source: 'cd',
                //     purchaseType: 'new',
                //     country: 'All',
                //     product: 'aps10',
                //     runtime: 12,
                //     devices: 1,
                // };

                // const firstYearPricePromotionPrime25 = {
                //     type: 'public',
                //     source: 'cd',
                //     purchaseType: 'new',
                //     country: 'All',
                //     product: 'aps20',
                //     runtime: 12,
                //     devices: 1,
                // };

                // this.FlexiblePromotionsRestService
                //     .getPromotion(firstYearPricePromotionAntivirus).then((response) => {

                //         [this.$rootScope.firstYearPrices.aapd5] = response.data.data;

                //     });

                // this.FlexiblePromotionsRestService
                //     .getPromotion(firstYearPricePromotionAIA).then((response) => {

                //         [this.$rootScope.firstYearPrices.adwp1] = response.data.data;

                //     });

                // this.FlexiblePromotionsRestService
                //     .getPromotion(firstYearPricePromotionPrime5).then((response) => {

                //         [this.$rootScope.firstYearPrices.aps10] = response.data.data;

                //     });

                // this.FlexiblePromotionsRestService
                //     .getPromotion(firstYearPricePromotionPrime25).then((response) => {

                //         [this.$rootScope.firstYearPrices.aps20] = response.data.data;

                //     });

                Promise.allSettled = (promises) => {

                    const mappedPromises = promises.map(p => p
                        .then(value => ({
                            status: 'fulfilled',
                            value,
                        }))
                        .catch(reason => ({
                            status: 'rejected',
                            reason,
                        })));
                    return Promise.all(mappedPromises);

                };

                Promise.allSettled(promotionsPromises).then((results) => {

                    results.forEach((result) => {

                        if (result.status === 'fulfilled') {

                            promotionsResponses =
                                promotionsResponses.concat(result.value.data.data);

                        }

                    });

                    this.FlexiblePromotionsRepository.add(promotionsResponses);

                });

                appPricesPromiseQ.resolve();

            });

            // wait for all resources to be loaded
            this.$q.all([
                devicesPromise.promise, appIntegrationsPromise, appInstancesPromise.promise,
                licensesPromise.promise, usersPromiseQ.promise, paymentTypesPromiseQ.promise,
                activationCodesPromiseQ.promise, GdprActionsPromiseQ.promise,
                appPricesPromiseQ.promise, aiaStatusApiPromiseQ.promise,
            ]).then(() => {

                // resolve promise and hide dashboard loading state
                dashboardPromise.resolve();

            }).catch((error) => {

                const errorLocation = 'Dashboard Resolver';

                dashboardPromise.reject();
                this.ErrorHandler.handleError(error, errorLocation);

            });

        }

        return dashboardPromise.promise;

    }

}

_serviceDependencies.push(DashboardResolver);

angular.module('services')
    .service('DashboardResolver', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/common/resolvers/dashboardResolver.js